import React, { useEffect, useState } from "react";
import Container from "../../components/Container";
import { connect } from "react-redux";
import { logIn, fetch } from "../../actions/index";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import SelectFabricantes from "../../components/SelectFabricantes";
import SelectFiltros from "../../components/SelectFiltros";
import SelectLojas from "../../components/SelectLojas";
import { useFetch } from './../../components/Hooks/Conexao';
import { LoadingScreenBlank } from './../../components/Diversos';
import HeaderHiddenMenu from "../Menu/HeaderHiddenMenu";

function Func(props) {
    const [token, listarToken, loadingToken] = useFetch(() => props.fetch().post("/outros/getpowerbitoken"));
    const [filtros, setFiltros] = useState({});
    const filterFabricante = props.pesq?.fabricante?.map(x => x.nome.trim());
    const filterGrupo = props.pesq?.grupo?.map(x => x.nome.trim());
    const filterSetor = props.pesq?.setor?.map(x => x.nome.trim());
    const filterCnpj = props.pesq?.empresa?.filter(x => !!x.cnpj)?.map(x => x.cnpj?.trim());

    const loading = !filterFabricante || !filterFabricante.length ||
        !filterGrupo || !filterGrupo.length ||
        !filterSetor || !filterSetor.length ||
        !filterCnpj || !filterCnpj.length ||
        !token;


    let fab = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
            table: "analise (Matconlab)",
            column: "FABRICANTE PADRÃO"
        },
        operator: "In",
        values: filterFabricante
    };

    let set = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
            table: "analise (Matconlab)",
            column: "SETOR PADRÃO"
        },
        operator: "In",
        values: filterSetor
    };

    let gru = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
            table: "analise (Matconlab)",
            column: "GRUPO PADRÃO"
        },
        operator: "In",
        values: filterGrupo
    };

    let cnpj = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
            table: "analise (Matconlab)",
            column: "Cnpj"
        },
        operator: "In",
        values: filterCnpj
    };

    useEffect(() => {
        // document.getElementById('root').style.background = '#3c4551';
        listarToken()
    }, [])

    if (loading) {
        return <>
            {loading && <LoadingScreenBlank loading={loading} />}
            <div style={{ display: 'none' }}>
                <SelectLojas value={filtros.lojas} setValue={v => setFiltros(state => { return { ...state, lojas: v } })} />
                <SelectFabricantes value={filtros.fabricantes} onChange={v => setFiltros({ ...filtros, fabricantes: v })} mode="multiple" maxTagCount={2} />
                <SelectFiltros modelo="setor" placeholder="Setor" value={filtros.setor} onChange={v => setFiltros({ ...filtros, setor: v })} mode="multiple" maxTagCount={2} />
                <SelectFiltros modelo="grupo" placeholder="Grupo" value={filtros.grupos} onChange={v => setFiltros({ ...filtros, grupos: v })} mode="multiple" maxTagCount={2} />
            </div>
        </>
    }



    return (
        <div style={{ position: 'relative' }}>
            <HeaderHiddenMenu />
            <div>
                {/* <div>
                    <pre>FABRICANTES: {JSON.stringify(filterFabricante)}</pre>
                    <pre>GRUPOS: {JSON.stringify(filterGrupo)}</pre>
                    <pre>SETORES: {JSON.stringify(filterSetor)}</pre>
                    <pre>CNPJ: {JSON.stringify(filterCnpj)}</pre>
                    <pre>{props.match.params.token}</pre>
                </div> */}

                {!loading && <div>
                    <PowerBIEmbed
                        embedConfig={{
                            type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                            id: 'cf7815f9-59fe-448c-b7f2-2855af09a0e4',
                            embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=cf7815f9-59fe-448c-b7f2-2855af09a0e4',
                            accessToken: token,
                            tokenType: models.TokenType.Aad,
                            //filters: [fab, set, gru, cnpj],
                            filters: [fab, set, cnpj],
                            pageName: PowerBIEmbed.pageName,
                            settings:
                            {
                                panes:
                                {
                                    filters:
                                    {
                                        expanded: false,
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: false
                                    }

                                }
                            },
                        }}

                        eventHandlers={
                            new Map([
                                ['loaded', function () { console.log('Report loaded'); }],
                                ['rendered', function () { console.log('Report rendered'); }],
                                ['error', function (event) { console.log(event.detail); }]
                            ])
                        }

                        cssClassName={"powerbi-container"}

                        getEmbeddedComponent={(embeddedReport) => {
                            window.report = embeddedReport;
                        }}
                    />
                </div>}

            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return { pesq: state.pesq };
};
export default connect(mapStateToProps, { logIn, fetch })(Func);
